import { FC, useDeferredValue, useCallback, useState } from 'react'
import { useWasmContext } from '../providers'
import { FeedTopSection } from './top'
import { DomainList } from './domain-list'
import { useIssueFeedStyles } from './use-feed-issues-style'
import { useToast } from '@app/@/components/ui/use-toast'
import { useTranslation } from '@app/lib/hooks/useTranslation'

type LiveFeedProps = { small?: boolean; hideSync?: boolean; demo?: boolean }

// side panel that appears fixed on the right of current issues of domain being. This returns a list of pages with a list of issues per page.
export const IssueFeedMock: FC<LiveFeedProps> = ({ hideSync, demo }) => {
  //   const { t } = useTranslation(demo ? 'demo' : 'dashboard')
  const { feed } = useWasmContext()
  const { toast } = useToast()
  const { t } = useTranslation()

  const [feedOpen, setIssueFeedContent] = useState<boolean>(false)
  const [_, updater] = useState<number>(0)

  const { mainStyle, topStyles } = useIssueFeedStyles({ feedOpen, hideSync })

  const websites = useDeferredValue(feed?.get_data_keys() ?? [])

  const onScanEvent = useCallback(
    async (_: string) => {
      toast({
        title: t('dashboard:scan-progress'),
      })
      return
    },
    [toast, t]
  )

  const forceUpdate = useCallback(() => updater((x) => x + 1), [updater])

  const clearData = useCallback(() => {
    feed?.clear_data()
    forceUpdate()
  }, [feed, forceUpdate])

  return (
    <>
      {feedOpen ? <style>{`body { overflow: hidden; }`}</style> : null}
      <div className={mainStyle} aria-live='polite'>
        <div className={topStyles}>
          <FeedTopSection
            open={feedOpen}
            feedExist={websites.length}
            hideSync={hideSync}
            onClick={setIssueFeedContent}
            clearFeed={clearData}
          />
          <DomainList
            websites={websites}
            onScanEvent={onScanEvent}
            feed={feed}
            demo={demo}
          />
        </div>
      </div>
    </>
  )
}
